<template>
	<div class="">
		<!-- Hero -->
		<base-page-heading
			title="Photoframes"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="photoframeShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<PhotoFrameTable
				ref="updatePhotoframe"
				@routePhotoframe="routePhotoframe"
				@openInNewTab="openInNewTab"
			/>
		</div>
	</div>
</template>
